import { Grid } from '@mui/material';
import { useParams } from 'react-router';
import { PageContainer } from '@/components/shared/page-container';
import { LessonsProvider } from '@/packages/eduplay/context/lessons';
import { CompletedCourseDialog } from '@/packages/eduplay/pages/course/components/completed-course-dialog';
import { VideoLesson } from '@/packages/eduplay/pages/course/components/video-lesson';
import { VideoLessonsList } from '@/packages/eduplay/pages/course/components/video-lessons-list';

export const Course = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <PageContainer>
      <LessonsProvider courseId={Number(id)}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 8 }}>
            <VideoLesson />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <VideoLessonsList />
          </Grid>
        </Grid>
        <CompletedCourseDialog />
      </LessonsProvider>
    </PageContainer>
  );
};
